import { User } from '../../types/items';
import { FilterMap } from '../../types/main';
import { is, roles } from '../../utility/guard';

export const makeFilterMap = (user: User, customFilterMap: FilterMap[] | undefined) => {
  const defaultFilter = (customFilterMap) || [
    {
      key: 'user_owner_id',
      label: 'Mine',
      value: user.id,
    },
    {
      key: 'organization_id',
      label: "My Organization's",
      value: user.organization_id,
    },
    {
      key: 'following',
      label: 'I am following',
      value: 1,
    },
    {
      key: 'public',
      label: 'Public',
      value: 1,
    },
    {
      key: 'admin',
      label: 'Admin',
      value: 1,
      guard: is(roles.superAdmin),
    },
    {
      key: 'user_id',
      value: user.id,
      label: 'Mine',
    },
  ];

  return defaultFilter.filter((filter) => !filter.guard || filter.guard(user))
    .map(({ guard: _, ...filter }) => filter);
};
